import React from 'react';

export const NoBullet: React.FunctionComponent = () => {
  return (
    <svg width="38" height="38" viewBox="0 0 38 38" fill="none">
      <path d="M0 38L38 0" stroke="#FC3D2F" />
    </svg>
  );
};
